/* Yū influencer page — add-to-cart, add-all and copy-code buttons.
   Adds through /cart/add.js, then fires the theme's own ajaxProduct:added
   event (as quick-add.js does) so the cart drawer refreshes and opens. */
(function () {
  if (window.YuInfluencerPage) return;
  window.YuInfluencerPage = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // The influencer's code, when the code bar has "Apply the code automatically" on.
  var applyEl = document.querySelector('[data-inf-apply]');
  var applyCode = applyEl ? applyEl.getAttribute('data-inf-apply') : '';

  // Shopify's /discount/<code> link applies the code to the shopper's cart and
  // session. Ask it to answer with the cart JSON instead of a whole page.
  function applyDiscount() {
    if (!applyCode) return Promise.resolve();
    return fetch(root + 'discount/' + encodeURIComponent(applyCode) + '?redirect=' + encodeURIComponent(root + 'cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).catch(function (err) { console.error('Influencer code could not be applied', err); });
  }
  applyDiscount();

  function addItems(items, btn) {
    btn.classList.add('btn--loading');
    btn.disabled = true;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status === 422 || data.status === 'bad_request') {
          if (data.description) alert(data.description);
          return;
        }
        // Re-apply the code now the cart has items, then let the drawer refresh.
        return applyDiscount().then(function () {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: btn }
          }));
        });
      })
      .catch(function (err) { console.error('Influencer add to cart failed', err); })
      .then(function () {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      });
  }

  // Sticky code bar: pin its section just under the site header, which is
  // sticky itself and shrinks on scroll, so the offset is re-measured.
  function placeStickyBars() {
    var bars = document.querySelectorAll('[data-inf-sticky]');
    if (!bars.length) return;
    var header = document.querySelector('.header-section');
    var top = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }
    bars.forEach(function (bar) {
      var wrap = bar.closest('.shopify-section') || bar;
      wrap.style.position = 'sticky';
      wrap.style.top = top + 'px';
      wrap.style.zIndex = '19';
    });
  }
  var stickyQueued = false;
  function queueSticky() {
    if (stickyQueued) return;
    stickyQueued = true;
    requestAnimationFrame(function () { stickyQueued = false; placeStickyBars(); });
  }
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);
  document.addEventListener('headerStickyChange', function () { setTimeout(placeStickyBars, 50); setTimeout(placeStickyBars, 450); });
  document.addEventListener('shopify:section:load', queueSticky);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeStickyBars);
  else placeStickyBars();

  document.addEventListener('click', function (e) {
    var one = e.target.closest('[data-inf-add]');
    if (one) {
      e.preventDefault();
      var card = one.closest('[data-inf-card]');
      var select = card && card.querySelector('[data-inf-variant]');
      var id = select ? select.value : one.getAttribute('data-variant-id');
      if (id) addItems([{ id: Number(id), quantity: 1 }], one);
      return;
    }

    var all = e.target.closest('[data-inf-add-all]');
    if (all) {
      e.preventDefault();
      var ids = (all.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
      if (ids.length) addItems(ids.map(function (v) { return { id: Number(v), quantity: 1 }; }), all);
      return;
    }

    var copy = e.target.closest('[data-inf-copy]');
    if (copy && navigator.clipboard) {
      e.preventDefault();
      var label = copy.textContent;
      navigator.clipboard.writeText(copy.getAttribute('data-inf-copy')).then(function () {
        copy.textContent = copy.getAttribute('data-copied-label') || 'Copied';
        setTimeout(function () { copy.textContent = label; }, 1800);
      });
    }
  });
})();
